// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-4f885271]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.suppliy-info-title[data-v-4f885271] {\n  font-weight: 600;\n  padding-bottom: 20px;\n  font-size: 16px;\n}\n.content[data-v-4f885271] {\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
